// extracted by mini-css-extract-plugin
export default {"saveButton":"nav-save-option-module__saveButton--Dsu_N","saveAndSubmitButton":"nav-save-option-module__saveAndSubmitButton--alk4y"};